import { Directive } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Directive({
  standalone: true,
  selector: '[libTrimmedValue]',
})
export class TrimmedValueDirective {
  constructor(ngControl: NgControl) {
    if (ngControl.valueAccessor) {
      this.trimValueAccessor(ngControl.valueAccessor);
    }
  }

  private trimValueAccessor(valueAccessor: ControlValueAccessor) {
    const original = valueAccessor.registerOnChange;
    valueAccessor.registerOnChange = (fn: any) =>
      original.call(valueAccessor, (value: any) => fn(typeof value === 'string' ? value?.trim() : value));
  }
}
